import React from "react";
import { QuizSectionHeader } from "./quiz-blocks";
import { ImageBuilder } from "../../global/image-builder";
import { cn } from "../../../lib/helpers";

export const QuizVillains = () => {
  const villains = [
    {
      id: "frankenstack",
      name: "The Frankenstack",
      image: "/img/quiz/villain-frankenstack.png",
      promise: "One more data scrape should do it.",
      reality: "Brittle systems break and complicated data flows require a PhD.",
      looksLike: "Stitching together spreadsheets, fighting data fires, needing an engineering degree just to hit send.",
      cost: "As GTM complexity grows, execution is traded for maintenance.",
      position: "left",
      color: "#D4B783"
    },
    {
      id: "fragmenter",
      name: "The Fragmenter",
      image: "/img/quiz/villain-fragment.png",
      promise: "Pieces of the puzzle are plenty.",
      reality: "Outreach built on partial context misses the mark.",
      looksLike: "Logging in and out of point solutions, missing hand-raisers in the crowd, chasing false positives.",
      cost: "Pipeline plummets while trust in GTM systems collapses.",
      position: "right",
      color: "#9DD691"
    },
    {
      id: "spamcannon",
      name: "The Spam Cannon",
      image: "/img/quiz/villain-spamcannon.png",
      promise: "More emails means more opportunities.",
      reality: "Spray-and-pray AI floods inboxes with generic personalization.",
      looksLike: "Burning through your TAM in a day, sending messages that go straight to spam, cringing at college mascot references.",
      cost: "Conversion craters and brand reputation is demolished.",
      position: "left",
      color: "#E2653B"
    }
  ];

  return (
    <>
      <QuizSectionHeader
        bgTitle="The Villains"
        title="Beware problems masquerading as pipegen solutions"
        summary="The Frankenstack, Fragmenter, and Spam Cannon promise solutions—but they're counterfeits that cost you pipeline in the end."
      />
      <div className="space-y-8 md:space-y-12">
        {villains.map((villain) => (
          <div
            key={villain.id}
            className={cn(
              "grid md:grid-cols-4 gap-8 items-center font-openSans",
              villain.position === "right" ? "md:grid-flow-col-dense" : ""
            )}
          >
            {/* Character Card */}
            <div className={cn("col-span-3 flex justify-center md:col-span-1", villain.position === "right" ? "md:col-start-4" : "")}>
              <ImageBuilder
                src={villain.image}
                alt={villain.name}
                className="rounded-xl border-4"
                height={354}
                style={{
                  height: '354px',
                  objectFit: 'cover',
                  borderColor: villain.color,
                }}
              />
            </div>

            {/* Content */}
            <div className={cn(
              "col-span-3 border border-light-10 bg-gray-1000 p-6 lg:p-12 rounded-xl h-full flex flex-col justify-around",
              villain.position === "right" ? "md:col-start-1" : ""
            )}>
              <h3
                className="text-5xl text-center lg:text-8xl font-superhero font-bold text-white uppercase italic"
                style={{
                  color: villain.color,
                }}
              >
                {villain.name}
              </h3>

              <div className="space-y-4 text-light-60 mt-6 leading-normal">
                <div className="grid grid-cols-1/4-3/4 gap-2 items-start">
                  <span className="text-white font-semibold">Promise:</span>
                  <p>&ldquo;{villain.promise}&rdquo;</p>
                </div>

                <div className="grid grid-cols-1/4-3/4 gap-2 items-start">
                  <span className="text-white font-semibold">Reality:</span>
                  <p>{villain.reality}</p>
                </div>

                <div className="grid grid-cols-1/4-3/4 gap-2 items-start">
                  <span className="text-white font-semibold">Looks Like:</span>
                  <p>{villain.looksLike}</p>
                </div>

                <div className="grid grid-cols-1/4-3/4 gap-2 items-start">
                  <span className="text-white font-semibold">Cost:</span>
                  <p className="font-medium">{villain.cost}</p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};